import type { ReactNode } from "react";
import cn from "classnames";
import Emojify from "app/components/shared/Emojify";
import { twMerge } from "tailwind-merge";

export const getFirstEmoji = (label: string): string | null => {
  const emojiPattern = /:(\w+):/;
  const match = label.match(emojiPattern);

  return match ? match[0] : null;
};

export default function Label({
  label,
  icon = undefined,
  className = undefined,
}: {
  label: string;
  icon?: ReactNode;
  className?: string;
}) {
  const firstEmoji = getFirstEmoji(label);
  const labelText = firstEmoji
    ? label.replace(firstEmoji, "").trimStart()
    : label;

  return (
    <header
      className={twMerge("flex", "gap-3", "items-center", "pr-4", className)}
    >
      {icon}
      {firstEmoji && (
        <Emojify
          text={firstEmoji}
          className="flex shrink-0 items-center text-2xl h-6 w-6 [&_img]:h-auto [&_img]:w-auto"
        />
      )}
      <Emojify
        text={labelText}
        className={cn(
          ["inline-flex", "gap-1", "items-center"],
          ["font-medium", "text-lg", "text-slate-900"],
        )}
      />
    </header>
  );
}
